<template>
  <div>
    <el-alert
      v-if="!distributor_id && !IS_DISTRIBUTOR"
      title="请从【门店作息管理】菜单进入"
      type="warning">
    </el-alert>
    <div v-else>
      <div v-if="distributor_id" style="margin-bottom: 20px;">
        {{ distributor_name }}
        <div style="color: #888;font-size: 13px;margin-top: 8px">
          Apple ID：{{ shop_code }}
        </div>
      </div>
      <el-card v-for="item in data" :key="item.session_week" class="box-card">
        <el-table :data="item.sessions"
          :header-cell-style="{ background: '#ecf5ff', color: '#606266', 'font-weight': 650 }">
          <el-table-column prop="id" label="场次ID" width="90" />
          <el-table-column prop="session_name" label="场次名称" />
          <el-table-column label="状态" width="100">
            <template slot-scope="scope">
              <span :style="{ color: scope.row.pause ? '#E6A23C' : '#409EFF' }">
                {{ scope.row.pause ? '暂停预约' : '可预约' }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="不可维修产品">
            <template slot-scope="scope">
              <div v-if="scope.row.not_repairable_products && scope.row.not_repairable_products.length">
                <span v-for="p in scope.row.not_repairable_products" :key="p.product_id">{{ p.product_name }} </span>
              </div>
              <span v-else>不限制</span>
            </template>
          </el-table-column>
          <el-table-column prop="quota" label="场次名额" width="100">
            <template slot-scope="scope">
              {{ scope.row.quota == -1 ? '不限制' : scope.row.quota }}
            </template>
          </el-table-column>
          <el-table-column prop="session_end_time" label="最后可预约时间" width="120" />
          <el-table-column prop="use_end_time" label="最晚可履约时间" width="120" />
          <el-table-column v-if="canPause || canSetNotRepairable" label="操作" fixed="right" width="180">
            <template slot-scope="scope">
              <el-button v-if="canSetNotRepairable" type="text" size="small" @click="openNotRepairable(scope.row)">不可维修产品</el-button>
              <el-button v-if="canPause && !scope.row.pause" type="text" size="small" @click="openPause(scope.row)">暂停预约</el-button>
              <el-button v-if="canPause && scope.row.pause" type="text" size="small" @click="handleResume(scope.row)">开启预约</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>

    <el-dialog title="不可维修产品" :visible.sync="notRepairableVisible" width="600px">
      <el-form label-width="120px">
        <el-form-item label="不可维修商品">
          <el-select placeholder="请选择" v-model="notRepairableForm.not_repairable_product_ids" multiple style="width: 100%">
            <el-option v-for="item in options" :key="item.product_id" :label="item.product_name" :value="item.product_id" />
          </el-select>
          <p class="tips">不设置即为不限制</p>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="notRepairableVisible = false">取消</el-button>
        <el-button type="primary" @click="submitNotRepairable">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="暂停预约" :visible.sync="pauseVisible" width="480px">
      <el-form label-width="120px">
        <el-form-item label="暂停周数">
          <el-input-number v-model="pauseForm.pause_weeks" :min="1" :step="1" />
        </el-form-item>
        <el-form-item label="说明">
          <div class="pause-tips">
            <div>从本周起，一共暂停 {{ pauseWeeks }} 周，到期自动恢复可预约；如需提前恢复，点击「开启预约」。</div>
            <div>大概恢复时间：{{ pauseResumeText }}</div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="pauseVisible = false">取消</el-button>
        <el-button type="primary" @click="submitPause">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import {
  getDistributorSessions,
  changeDistributorSessionsStatus,
  getDistributorProductsContents,
  getDistributorSessionsDetail,
  updateDistributorSessionNotRepairable,
  resumeDistributorSession
} from '../../../api/workandrest'
import { IS_DISTRIBUTOR } from '@/utils'

export default {
  data () {
    return {
      data: [],
      options: [],
      distributor_id: undefined,
      distributor_name: '',
      shop_code: undefined,
      IS_DISTRIBUTOR: IS_DISTRIBUTOR(),
      notRepairableVisible: false,
      pauseVisible: false,
      notRepairableForm: { id: '', not_repairable_product_ids: [] },
      pauseForm: { session_id: '', pause_weeks: 1 }
    }
  },
  mounted () {
    if (this.$route.query) {
      const { distributor_id, distributor_name, shop_code } = this.$route.query
      this.distributor_id = distributor_id
      this.distributor_name = distributor_name
      this.shop_code = shop_code
    }
    if (!this.distributor_id && !this.IS_DISTRIBUTOR) return
    this.getList()
    this.getRepairGoods()
  },
  computed: {
    ...mapGetters(['shopId']),
    canPause () {
      return this.hasMenuPermission('sessions', 'repairsessions_pause')
    },
    canSetNotRepairable () {
      return this.hasMenuPermission('sessions', 'repairsessions_not_repairable')
    },
    pauseWeeks () {
      const n = Number(this.pauseForm.pause_weeks)
      return n > 0 ? n : 0
    },
    // 暂停恢复时刻：本周一 00:00 + N*7 天 − 1 秒（与后端 PlatformRepairSessionService::buildPauseUntil 规则一致）
    pauseResumeAt () {
      if (!this.pauseWeeks) return 0
      const now = new Date()
      const dayOfWeek = (now.getDay() + 6) % 7 + 1 // 1=周一 … 7=周日
      const monday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - (dayOfWeek - 1), 0, 0, 0, 0)
      return monday.getTime() + this.pauseWeeks * 7 * 86400 * 1000 - 1000
    },
    pauseResumeText () {
      if (!this.pauseResumeAt) return ''
      const d = new Date(this.pauseResumeAt)
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    }
  },
  methods: {
    getList () {
      getDistributorSessions({ distributor_id: this.distributor_id }).then(res => {
        this.data = res.data.data
      })
    },
    getRepairGoods () {
      getDistributorProductsContents(this.shopId || this.distributor_id).then(res => {
        this.options = res.data.data
      })
    },
    openNotRepairable (row) {
      if (!this.canSetNotRepairable) return
      getDistributorSessionsDetail({ id: row.id, distributor_id: this.distributor_id }).then(res => {
        const data = res.data.data
        this.notRepairableForm = {
          id: row.id,
          not_repairable_product_ids: (data.not_repairable_products || []).map(item => item.product_id)
        }
        this.notRepairableVisible = true
      })
    },
    submitNotRepairable () {
      if (!this.canSetNotRepairable) return
      updateDistributorSessionNotRepairable({
        id: this.notRepairableForm.id,
        not_repairable_product_ids: this.notRepairableForm.not_repairable_product_ids.join(','),
        distributor_id: this.distributor_id
      }).then(() => {
        this.$message.success('保存成功')
        this.notRepairableVisible = false
        this.getList()
      })
    },
    openPause (row) {
      if (!this.canPause) return
      this.pauseForm = { session_id: row.id, pause_weeks: 1 }
      this.pauseVisible = true
    },
    submitPause () {
      if (!this.canPause) return
      changeDistributorSessionsStatus({
        session_ids: String(this.pauseForm.session_id),
        pause: 1,
        pause_weeks: this.pauseForm.pause_weeks,
        distributor_id: this.distributor_id
      }).then(() => {
        this.$message.success('已暂停预约')
        this.pauseVisible = false
        this.getList()
      })
    },
    handleResume (row) {
      if (!this.canPause) return
      this.$confirm('确认提前开启该场次预约？', '提示', { type: 'warning' }).then(() => {
        resumeDistributorSession({
          session_id: row.id,
          distributor_id: this.distributor_id
        }).then(() => {
          this.$message.success('已开启预约')
          this.getList()
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.tips {
  line-height: 24px;
  font-size: 12px;
  color: #999;
}
.pause-tips {
  border: 1px solid #F56C6C;
  border-radius: 4px;
  padding: 12px;
  line-height: 22px;
  font-size: 13px;
  color: #606266;
}
.box-card {
  margin-bottom: 16px;
}
</style>
